import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import GameHolder from './gameholder';
import ModalView from './tools/modal';
import Leaderboard from './tools/leaderboard'


import { RiInformationFill } from 'react-icons/ri';
import { RiQuestionFill } from 'react-icons/ri';
import { MdLeaderboard } from 'react-icons/md';

import { Container, Col, Row, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import { Radio } from "./tools/radio";

const baseURL = (process.env.REACT_APP_BACK_SERVER || '').replace(/\/?$/, '/');

function Harmonia() {

  let instruction = "Create as many 3- or 4-chord progressions as possible by selecting only adjacent chords.<br /><br /> The scoring system is as follows: <br /> Each 3-chord progression = 2 pts <br /> Each 4-chord progression = 4 pts <br /> Each inappropriate progression = -1 pt <br /> <br /> ";

  instruction += "The following rules apply: <br /> <ol><li>Do not repeat the exact same chord (e.g. not I-I, but I-Ib or Ib-I is allowed) </li><li>End each progression with a common tonal cadence (namely, perfect cadence, imperfect cadence, plagal cadence, or interrupted cadence).<ol type='a'><li>Standard plagal expansion of the cadential tonic (namely, I-IVc-I) is allowed as long as the key is established.</li><li>Inverted cadences (e.g. Vb-I) and other weaker cadential forms (e.g. vii<sup>o</sup>b-I, V<sup>7</sup>d-Ib) are allowed.</li><li>Do not repeat the second cadential chord by inverting it (e.g. V-Ib-I, V-I-Ib, I-V-Vb, I-Vb-V).</li></ol></li><li>Each progression should aim for a good bassline.</li></ol>";

  let about = "Harmonia<sup>TM</sup> is a music game designed by Assoc. Prof Eddy K. M. Chong from the Visual and Performing Arts Academic Group with the help of the Centre for Innovation in Learning, National Institute of Education, Singapore. <br /><br /> Inspired by the game Boggle, Harmonia uses a 5x5 grid of chord symbols. A choice between the American and British chord symbols is given. Players then create as many western classical-style chord progressions as possible in either the major or minor key, and within a chosen duration of 2, 5, 10 or 15 min. <br /><br />The scores within each duration category will be ranked. The players’ average time per correct progression will also be ranked regardless of the duration category. Those who get into the top 5 will be prompted to identify themselves and be featured in the leaderboard.";
  


  const [opening, setOpening] = useState(true);
  const [startGame, setStartGame] = useState(false);
  const [selectedInput, setSelectedInput] = useState("2:0");
  const [selectedInputKey, setSelectedInputKey] = useState("major");
  const [selectedInputChord, setSelectedInputChord] = useState("American");
  const [selectedInputSound, setSelectedInputSound] = useState("on");

  const [selected, setSelected] = useState("first");

  const [code, setCode] = useState(""); //code typed in by user
  const [wrongcode, setWrongcode] = useState(""); //display label when user key in the wrong code 
  const [groupcode, setGroupcode] = useState(""); //code to be used for leaderboard later


  const settings = () => {

    
    if (code !== "") {
      let data = {};
      data["code"] = code.substring(0,3);;

      axios.post(baseURL + 'api/getGroupCode', data)
        .then(res => {
          if (res.data !== "not found") {
            setGroupcode(code);
            setOpening(false);
            setWrongcode("");
          
          } else
            setWrongcode("Code is incorrect. For public or users without code, please leave blank.");
        })
    } else { //for public users
      setGroupcode("public");
      setOpening(false);
      setWrongcode("");
      
    }

    
  }
  const play = () => {

      setStartGame(true);

  }

  const RadioInput = ({ name, label, value, isChecked, handleChange }) => {
    const handleRadioChange = e => {
      const { id } = e.currentTarget;
      handleChange(id); // Send back id to radio group for comparison
    };

    return (
      <div>
        {/* Target this input: opacity 0 */}
        <input
          type="radio"
          className="custom-radio"
          name={name}
          id={value} // htlmlFor targets this id.
          checked={isChecked}
          onChange={handleRadioChange}
        />
        <label htmlFor={value}>
          <span>{label}</span>
        </label>
      </div>
    );
  };



  const onSelectNewGame = (status) => {
    setStartGame(false);
  }


  return (
    <div>
     
      <Container className={` ${opening === true ? 'background' : 'backgroundback'}`} >
        <Row>
          <Col>

            <div className="d-flex flex-row-reverse">
              {startGame === false && <div><ModalView button={<RiInformationFill size={40} />} header="Instruction" content={instruction} /></div>}
              {startGame === false && <div><ModalView button={<RiQuestionFill size={40} />} header="About Harmonia" content={about} /></div>}
              {opening === false && startGame === false && <Leaderboard button={<MdLeaderboard size={40} />} header="LEADERBOARD" groupcode={groupcode}/> }
            </div>


          </Col>

        </Row>
        <Row>
          <Col>
            {opening === true && <><div className="title">Harmonia</div><br /></>}
            {startGame === true && <GameHolder groupcode={groupcode} duration={selectedInput} type={selectedInputKey} selectNewGame={onSelectNewGame} chord={selectedInputChord} volume={selectedInputSound} />}
          </Col>
        </Row>
        <Row>
          {opening === true &&
            <><Row>
              <Col className="text-center">
            
                  <div className="startButton">GROUP CODE</div>
              
                  <div className="groupCodeSmallText">FOR PUBLIC, PLEASE LEAVE BLANK</div>
                <label>
                  <input
                    className="groupCodeField"
                    placeholder=""
                    type="text"
                    value={code}
                    onChange={e => setCode(e.target.value)}
                  />
                </label>
                {wrongcode=== "" && <div className="groupCodeLabel">&nbsp;<br /></div>}
                  {wrongcode!== "" && <div className="groupCodeLabel">{wrongcode}<br /></div>}
                
              </Col>
            </Row>
              <Row>
                <Col className="text-center">
                  <Button className="startButton" onClick={settings}>Start</Button>
                </Col>
              </Row>
            </>
          }
          {opening === false && startGame === false && <Col>

            <Row>
              <Col xs={0} md={2}>
                &nbsp;
              </Col>
              <Col className="transparentBackground">
                <Row>
                  <Col xs={0} sm={1}>&nbsp;</Col>
                  <Col>
                    <Row>
                      <Col className="text-center">
                        <span className="settings">Settings</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12} lg={12} xl={4} className="settingsText d-flex flex-row align-items-center">
                        Duration:
                      </Col>
                      <Col >
                        <div className="d-flex flex-row align-items-center ">
                          <Radio
                            value="2:0"
                            text="2min"
                            selected={selectedInput}
                            onChange={setSelectedInput}
                          /> &nbsp;&nbsp;&nbsp;&nbsp;
                          <Radio
                            value="5:0"
                            text="5min"
                            selected={selectedInput}
                            onChange={setSelectedInput}
                          /> &nbsp;&nbsp;&nbsp;&nbsp;
                          <Radio
                            value="10:0"
                            text="10min"
                            selected={selectedInput}
                            onChange={setSelectedInput}
                          /> &nbsp;&nbsp;&nbsp;&nbsp;
                          <Radio
                            value="15:0"
                            text="15min"
                            selected={selectedInput}
                            onChange={setSelectedInput}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12} lg={12} xl={4} className="settingsText d-flex flex-row align-items-center">
                        Key:
                      </Col>
                      <Col >
                        <div className="d-flex flex-row align-items-center">
                          <Radio
                            value="major"
                            text="Major"
                            selected={selectedInputKey}
                            onChange={setSelectedInputKey}
                          /> &nbsp;&nbsp;&nbsp;&nbsp;
                          <Radio
                            value="minor"
                            text="Minor"
                            selected={selectedInputKey}
                            onChange={setSelectedInputKey}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12} lg={12} xl={4} className="settingsText d-flex flex-row align-items-center">
                        Chord system:
                      </Col>
                      <Col >
                        <div className="d-flex flex-row align-items-center ">
                          <Radio
                            value="American"
                            text="N.American system"
                            selected={selectedInputChord}
                            onChange={setSelectedInputChord}
                          /> &nbsp;&nbsp;&nbsp;&nbsp;
                          <Radio
                            value="British"
                            text="British"
                            selected={selectedInputChord}
                            onChange={setSelectedInputChord}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12} lg={12} xl={4} className="settingsText d-flex flex-row align-items-center">
                        Sound:
                      </Col>
                      <Col >
                        <div className="d-flex flex-row align-items-center ">
                          <Radio
                            value="on"
                            text="On"
                            selected={selectedInputSound}
                            onChange={setSelectedInputSound}
                          /> &nbsp;&nbsp;&nbsp;&nbsp;
                          <Radio
                            value="off"
                            text="Off"
                            selected={selectedInputSound}
                            onChange={setSelectedInputSound}
                          />
                        </div>
                      </Col>
                    </Row>




                    <Row><Col className="text-center">
                      <Button className="startButton" onClick={play}>Play</Button>
                    </Col>
                    </Row>
                  </Col>
                  <Col xs={0} sm={1}>&nbsp;</Col>
                </Row>
              </Col>
              <Col xs={0} md={2}>
                &nbsp;
              </Col>
            </Row>
          </Col>
          }


        </Row>

      </Container>
    </div>
  )
}



ReactDOM.render(<Harmonia />, document.getElementById('root'));